import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Collection, CollectionAction, CollectionResponse } from '../interfaces/collection.interface';
import { CONTROLLER_CONSTANTS } from '../../../shared/constants/controller.constants';
import { ENDPOINT_CONSTANTS } from '../../../shared/constants/endpoint.constants';
import { BaseHttpService } from '../../../shared/services/base-http.service';

@Injectable({
  providedIn: 'root'
})
export class CollectionsService {
  private collectionsSubject = new BehaviorSubject<Collection[]>([]);
  public collections$ = this.collectionsSubject.asObservable();

  constructor(private baseHttp: BaseHttpService) {
  }



  // getCollections(): Observable<Collection[]> {
  //   return this.collections$;
  // }
  getCollections(): Observable<CollectionResponse> {
    const endpoint = `/${CONTROLLER_CONSTANTS.COLLECTION}/${ENDPOINT_CONSTANTS.GET_COLLECTIONS}`;
    return this.baseHttp.get<CollectionResponse>(endpoint);
  }

  getCollectionById(id: string): Observable<Collection | undefined> {
    return new Observable(observer => {
      this.collections$.subscribe(collections => {
        const collection = collections.find(c => c.id === id);
        observer.next(collection);
      });
    });
  }
  updateText(payload: any): Observable<any> {
    const endpoint = `/${CONTROLLER_CONSTANTS.COLLECTION}/${ENDPOINT_CONSTANTS.UPDATE_TEXT}`;
    return this.baseHttp.post<any>(endpoint, payload);
  }
  deleteText(payload: any): Observable<any> {
    const endpoint = `/${CONTROLLER_CONSTANTS.COLLECTION}/${ENDPOINT_CONSTANTS.DELETE_TEXT}`;
    return this.baseHttp.post<any>(endpoint, payload);
  }
  deleteDocument(payload: any): Observable<any> {
  const endpoint = `/${CONTROLLER_CONSTANTS.DOCUMENT}/${ENDPOINT_CONSTANTS.DELETE_DOCUMENT}`;
  return this.baseHttp.post<any>(endpoint, payload);
}



  performAction(action: CollectionAction): void {
    const currentCollections = this.collectionsSubject.value;
    let updatedCollections = [...currentCollections];

    switch (action.type) {
      case 'expand':
        updatedCollections = updatedCollections.map(collection =>
          collection.id === action.collectionId
            ? { ...collection, isExpanded: true }
            : collection
        );
        break;
      case 'collapse':
        updatedCollections = updatedCollections.map(collection =>
          collection.id === action.collectionId
            ? { ...collection, isExpanded: false }
            : collection
        );
        break;
      case 'activate_document':
        updatedCollections = updatedCollections.map(collection =>
          collection.id === action.collectionId
            ? { ...collection, activeDocumentId: action.documentId }
            : collection
        );
        break;
      case 'delete_text':
        updatedCollections = updatedCollections.map(collection => {
          if (collection.id !== action.collectionId) return collection;
          return {
            ...collection,
            texts: (collection.texts || []).filter(t => t.id !== action.documentId)
          };
        });
        break;
      case 'edit_text':
        updatedCollections = updatedCollections.map(collection => {
          if (collection.id !== action.collectionId) return collection;

          return {
            ...collection,
            texts: (collection.texts || []).map(t =>
              t.id === action.documentId
                ? {
                  ...t,
                  heading: action.payload.parent_heading, // keep previous heading if needed
                  text: action.payload.text
                }
                : t
            )
          };
        });
        break;

    }

    this.collectionsSubject.next(updatedCollections);
  }

  toggleCollectionExpansion(collectionId: string): void {
    const currentCollections = this.collectionsSubject.value;
    const collection = currentCollections.find(c => c.id === collectionId);

    if (collection) {
      this.performAction({
        type: collection.isExpanded ? 'collapse' : 'expand',
        collectionId: collectionId
      });
    }
  }
}
